export enum EStarTheme {
  Fillable = 'fillable',
  Filled = 'filled',
  NotFilled = 'notFilled',
}
